import {
  SidebarContainer,
  Icon,
  CloseIcon,
  PlayIcon,
  SidebarMenu,
  SidebarLink,
  SideBtnWrap,
  SidebarWrapper,
  SidebarRoute,

} from "./SidebarElements";

const Sidebar = ({ isOpen, toggle }) => {
  return (
    <SidebarContainer isOpen={isOpen} onClick={toggle}>
      <Icon onClick={toggle}>
        <CloseIcon />
      </Icon>
      <SidebarWrapper>
        <SidebarMenu>
          <SidebarLink to="Howitworks" onClick={toggle}>
            How It Works
            {/* TODO: add the icon when we have a video to play */}
            {/* <PlayIcon /> */}
          </SidebarLink>
          <SidebarLink to="Agents" onClick={toggle}>
            For Agents
          </SidebarLink>
          <SidebarLink to="FB" onClick={toggle}>
            For Business
          </SidebarLink>
          <SidebarLink to="Pricing" onClick={toggle}>
            Pricing
          </SidebarLink>
        </SidebarMenu>
        <SideBtnWrap>
          <SidebarRoute to="Waitlist" onClick={toggle}>
            Join Wait list
          </SidebarRoute>
        </SideBtnWrap>
      </SidebarWrapper>
    </SidebarContainer>
  );
};
export default Sidebar;
